// import { hpHttpClient } from 'root/api/http';
import { hpGqlClient } from 'root/api/';
import { crudActions } from 'root/store/helpers';
import { ProfileQuery } from './query';

const { create, filter, fetchMany, getById, update, deleteById } = hpGqlClient.profile;

export const actions = {
  ...crudActions('profile', {
    create, filter, fetchMany, getById, update, deleteById
  }, {
    queries: ProfileQuery,
  }),
};
